import { render, staticRenderFns } from "./ProjectFeature.vue?vue&type=template&id=112f1fce&scoped=true&"
import script from "./ProjectFeature.vue?vue&type=script&lang=js&"
export * from "./ProjectFeature.vue?vue&type=script&lang=js&"
import style0 from "./ProjectFeature.vue?vue&type=style&index=0&id=112f1fce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112f1fce",
  null
  
)

export default component.exports